import React from 'react';
import { MEMBERSHIP, NAFCENTER } from '@lib/constants';
import {
  useHandleBecomeMemberClick,
  useHandleBookAppointmentClick,
} from '../../../utils/Tracking/Navigation/NavigationTracking';
import { useTrackPromotion } from '../../../hooks/useTrackPromotion';
import { useWindowLocation } from '../../../hooks/Window/useWindowLocation';
import { shouldHideBecomeMemberButton } from '../../../utils/hideBecomeMemberButton';
import * as S from './NavigationButtons.styles';

interface NavigationButtonsProps {
  isLoggedIn?: boolean;
}

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({ isLoggedIn }) => {
  const handleBecomeMemberClick = useHandleBecomeMemberClick();
  const handleBookAppointmentClick = useHandleBookAppointmentClick();
  const currentUrl = useWindowLocation();
  const hideBecomeMemberButton = shouldHideBecomeMemberButton(currentUrl, { isAuthenticated: isLoggedIn });
  const ctaText = 'Bli medlem';

  const { wrapperRef, trackSelectPromotion } = useTrackPromotion({
    creative_slot: 'megamenu',
    creative_name: `CTA | signature | ${ctaText}`,
    disabled: Boolean(isLoggedIn || hideBecomeMemberButton),
  });

  return (
    <S.Wrapper ref={!isLoggedIn && !hideBecomeMemberButton ? wrapperRef : null}>
      {!isLoggedIn && !hideBecomeMemberButton && (
        <S.StyledSimbaButton
          size="small"
          aria-label={ctaText}
          type="button"
          variant="contained"
          color="primary"
          to={`${MEMBERSHIP}`}
          onClick={() => {
            trackSelectPromotion();
            handleBecomeMemberClick();
          }}
          textWrap="nowrap"
        >
          {ctaText}
        </S.StyledSimbaButton>
      )}
      <S.StyledSimbaButton
        data-hide-at-compact-navbar="true"
        size="small"
        aria-label="Bestill time"
        type="button"
        color="secondary"
        to={`${NAFCENTER}`}
        onClick={handleBookAppointmentClick}
        textWrap="nowrap"
      >
        Bestill time
      </S.StyledSimbaButton>
    </S.Wrapper>
  );
};
